import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
} from '@efexteam/components';
import clientSvc from '@efex-services/client/clientSvc';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { Alert, AlertTitle, Box, Grid2, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useApiCall } from 'use-api-call';

export interface DeleteAccountProps {
  open: boolean;
  close: (value: boolean) => void;
}

const DeleteAccount = ({ open, close }: DeleteAccountProps) => {
  const { t } = useTranslation();

  const {
    data,
    loading,
    error,
    invoke: deleteUserAccountRequest,
  } = useApiCall(() => clientSvc.deleteUserAccountRequest());

  const handleClose = () => {
    close(false);
  };

  const deleteAccount = () => {
    deleteUserAccountRequest();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle showCloseButton onClick={handleClose} />
      <DialogContent>
        <Box>
          {!data ? (
            <Grid2 container>
              <Grid2 size={12} className="text-center">
                <Typography variant="h6" className="!my-4 !text-center">
                  {t('deleteAccountMessage')}
                </Typography>
                <Typography variant="body1" className="!my-4 !text-center">
                  {t('deleteAccountSubMessage')}
                </Typography>
              </Grid2>
              {error ? (
                <Alert severity="error" className="!mb-4 w-full">
                  <AlertTitle>{t('errorRetryMessage')}</AlertTitle>
                  {t('tryOrContact')}{' '}
                  <strong>
                    <a href="mailto:sales@efexpay.com">sales@efexpay.com</a>
                  </strong>
                </Alert>
              ) : null}
              <Grid2
                size={12}
                className="flex !flex-col md:!flex-row justify-around"
              >
                <Button
                  appearance="primary"
                  size="large"
                  className="mt-4"
                  disabled={loading}
                  onClick={handleClose}
                >
                  {t('deleteAccountCancel')}
                </Button>
                <Button
                  appearance="primary"
                  size="large"
                  className="mt-4"
                  variant="outlined"
                  color="error"
                  disabled={loading}
                  onClick={deleteAccount}
                >
                  {loading ? <AutorenewIcon className="animate-spin" /> : null}
                  {t('deleteAccountConfirm')}
                </Button>
              </Grid2>
            </Grid2>
          ) : null}
          {data && data.status === 200 ? (
            <Grid2 container>
              <Grid2 size={12} className="!mb-5 text-center">
                <Typography variant="h6" className="!my-4 !text-center">
                  {t('deleteAccountConfirmMessage')}
                </Typography>
                <Typography variant="body1" className="!my-4 !text-center">
                  {t('deleteAccountConfirmSubMessage')}
                </Typography>
              </Grid2>
              <Grid2
                size={12}
                className="flex !flex-col md:!flex-row justify-around"
              >
                <Button
                  appearance="secondary"
                  size="large"
                  className="mt-4"
                  onClick={handleClose}
                >
                  {t('close')}
                </Button>
              </Grid2>
            </Grid2>
          ) : null}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteAccount;
